"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const order_1 = require("@/api/order");
const createOrder_vue_1 = __importDefault(require("../car/createOrder.vue"));
const cop_1 = __importDefault(require("@/components/packageSet/cop"));
const Lop_1 = __importDefault(require("@/components/packageSet/Lop"));
const wheel_1 = __importDefault(require("@/components/packageSet/wheel"));
const guide_1 = __importDefault(require("@/components/packageSet/guide"));
let About = class About extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.dialogVisible = false;
        this.activeNames = [];
        this.list = [];
        this.carList = [];
        this.replaceList = [];
        this.product = {};
        this.num = '1';
        this.price = 0;
        this.thSource = '';
        this.thSource2 = '';
        this.visible = false;
        this.goodsDetail = {};
        this.lopList = {};
        this.copList = {};
        this.wopList = {};
        this.gopList = {};
        this.fopList = {};
        this.showLop = false;
        this.showCop = false;
        this.showGuide = false;
        this.copType = '';
        this.showWeel = false;
        this.showlift = false;
    }
    onChangeNum(newValue, oldValue) {
        this.list.forEach(item => {
            item.forEach(val => {
                val.orderNum = val.orderNum * newValue / oldValue;
            });
        });
    }
    onChangePrice(newValue, oldValue) {
        // console.log('新的',newValue)
        let price = 0;
        newValue.forEach(item => {
            if (item.length == 0)
                return;
            item.forEach(val => {
                price += val.actualPrice * val.orderNum;
            });
        });
        this.price = price;
    }
    addCar() {
        this.carList = [...this.list[0], ...this.list[1], ...this.list[2], ...this.list[3], ...this.list[4], ...this.list[5]];
        this.visible = true;
        // console.log(this.list)
    }
    config(item) {
        this.goodsDetail = item;
        this.lopList = {};
        this.copList = {};
        this.wopList = {};
        this.gopList = {};
        this.fopList = {};
        if (item.setType == 1) {
            this.showLop = true; //LOP参数显示
            this.copType = item.model;
            if (item.suitConfig) {
                this.copList = JSON.parse(item.suitConfig);
            }
        }
        else if (item.setType == 2) {
            this.showCop = true;
            this.copType = item.model;
            if (item.suitConfig) {
                this.copList = JSON.parse(item.suitConfig);
            }
        }
        else if (item.setType == 4) {
            this.showGuide = true;
            this.copType = item.model;
            if (item.suitConfig) {
                this.copList = JSON.parse(item.suitConfig);
            }
            // this.showgoods02 = true //导轨参数显示
        }
        else if (item.setType == 3) {
            this.showWeel = true;
            this.copType = item.model;
            this.wheelId = item.itemNo;
            if (item.suitConfig) {
                this.copList = JSON.parse(item.suitConfig);
            }
            // this.showgoods08 = true //导向轮
        }
        // else if (item.chnitemName == '轿厢') {
        //   this.showlift = true
        //   this.copType = item.model
        //   if (item.suitConfig) {
        //     this.copList = JSON.parse(item.suitConfig)
        //   }
        // }
    }
    updataCop(item) {
        return __awaiter(this, void 0, void 0, function* () {
            this.goodsDetail.suitConfig = JSON.stringify(item);
            // console.log(this.list)
            if (this.showLop) {
                let logo = '';
                let duse = '';
                // 蓝光 24v 带盲文 SN-PB12 (pcs: 2)111|-|SFTC-HCB-D5 SN-HCB-D5有LOGO 镀色  1
                //console.log(item, 'items')
                if (item.haveLogo != '' && item.haveColor == '') {
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    this.goodsDetail.purchasePrice = pp + 20;
                }
                if (item.haveLogo != '' && item.haveColor != '') {
                    duse = '镀色';
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    this.goodsDetail.purchasePrice = pp + 30;
                }
                if (item.haveColor != '' && item.haveLogo == '') {
                    duse = '镀色';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    this.goodsDetail.purchasePrice = pp + 10;
                }
                // let salesPriceCk = (Number(this.goodsDetail.purchasePrice) / Number(this.rateR) / parseFloat(1 + Number(this.goodsDetail.rebate) / 100)) * (1 + (Number(this.goodsDetail.profitRateD) + Number(this.goodsDetail.profitRateG)) / 200)
                // console.log(item.lopButtonDesc04,"item.lopButtonDesc04")
                this.goodsDetail.chnitemproperty = item.lopDes + ' ' + item.lopButtonDesc01 + ' ' + item.lopButtonDesc02 + ' ' + item.lopButtonDesc03 + ' ' + item.lopButtonDesc04 + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ')' + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + logo + ' ' + duse + ' ' + item.haveColor01;
                this.goodsDetail.itemproperty = item.lop + ' ' + this.pingyin(item.lopButtonDesc01) + ' ' + item.lopButtonDesc02 + ' ' + this.pingyin(item.lopButtonDesc03) + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ')' + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + this.pingyin(logo) + ' ' + this.pingyin(duse) + ' ' + item.haveColor01;
            }
            if (this.showCop) {
                let logo = '';
                let duse = '';
                if (item.haveLogo != '' && item.haveColor == '') {
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    this.goodsDetail.purchasePrice = pp + 20;
                }
                if (item.haveLogo != '' && item.haveColor != '') {
                    duse = '镀色';
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    this.goodsDetail.purchasePrice = pp + 70;
                }
                if (item.haveColor != '' && item.haveLogo == '') {
                    duse = '镀色';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    this.goodsDetail.purchasePrice = pp + 50;
                }
                // let salesPriceCk = (Number(this.goodsDetail.purchasePrice) / Number(this.rateR) / parseFloat(1 + Number(this.goodsDetail.rebate) / 100)) * (1 + (Number(this.goodsDetail.profitRateD) + Number(this.goodsDetail.profitRateG)) / 200)
                let car = '';
                if (item.ccb) {
                    if (item.ccb.includes("&&")) {
                        car = ('电梯轿厢控制板:' + item.ccb.split('&&')[0].split('||')[0] + ';' + '电梯指令板:' + item.ccb.split('&&')[1].split('||')[0]);
                    }
                    else {
                        car = ('操纵箱指令板:' + item.ccb.split('||')[0]);
                    }
                }
                car = car + ';' + item.ccbDesc;
                let encar = '';
                if (item.ccb) {
                    if (item.ccb.includes("&&")) {
                        encar = ('Car Control Board:' + item.ccb.split('&&')[0].split('||')[0] + ';' + 'Car Call Board:' + item.ccb.split('&&')[1].split('||')[0]);
                    }
                    else {
                        encar = ('Command Board:' + item.ccb.split('||')[0]);
                    }
                }
                this.goodsDetail.chnitemproperty = 'floor:' + item.floor + ' ' + item.lopButtonDesc01 + ' ' + item.lopButtonDesc02 + ' ' + item.lopButtonDesc03 + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ') ' + item.floorContent + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + car + ' ' + logo + ' ' + duse + ' ' + item.haveColor01;
                this.goodsDetail.itemproperty = 'floor:' + item.floor + ' ' + this.pingyin(item.lopButtonDesc01) + ' ' + item.lopButtonDesc02 + ' ' + this.pingyin(item.lopButtonDesc03) + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ') ' + item.floorContent + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + encar + ' ' + this.pingyin(logo) + ' ' + this.pingyin(duse) + ' ' + item.haveColor01;
            }
            if (this.showGuide) {
                //   78*60*16.4mm  pcs : 2; Fish Plate-TK5AD  pcs : 3; T-Clips-TK5AD  pcs : 4; M10*30  pcs : 5;   pcs : 2; Fish Plate-TK5AD  pcs : 8; T-Clips-TK5AD  pcs : 4; M10*30  pcs : 5;
                this.goodsDetail.chnitemproperty = item.guideRail.split('||')[0] + ' ' + 'pcs:' + item.guideRailNums + ' ' + item.fishPlate.split('||')[0] + ' ' + 'pcs:' + ' ' + item.fishPlateNums + ' ' + item.tClips.split('||')[0] + ' ' + 'pcs:' + ' ' + item.tClipsNums + ' ' + ' ' + item.bolts.split('||')[0] + ' ' + 'pcs:' + ' ' + item.boltsNums;
                this.goodsDetail.itemproperty = item.guideRail.split('||')[0] + ' ' + 'pcs:' + item.guideRailNums + ' ' + item.fishPlate.split('||')[0] + 'pcs:' + ' ' + item.fishPlateNums + ' ' + item.tClips.split('||')[0] + ' ' + 'pcs:' + ' ' + item.tClipsNums + ' ' + item.bolts.split('||')[0] + 'pcs:' + ' ' + item.boltsNums;
            }
            if (this.showWeel) {
                //   console.log(item,'888')
                this.goodsDetail.chnitemproperty = item.wheel.split('||')[0] + ' ' + ':' + item.bearing.split('||')[0] + ' ' + item.sl.split('||')[0] + ' ' + item.check24 + ' ';
                const eng = (item.wheel.split('||')[0] + ' ' + ':' + item.bearing.split('||')[0] + ' ' + item.sl.split('||')[0] + ' ' + item.check24 + ' ');
                this.goodsDetail.itemproperty = eng.replace('国产', 'HRB').replace('人本', 'C&U');
            }
            this.close();
            this.goodsDetail.actualPrice = item.purchasePrice;
        });
    }
    close() {
        this.showCop = false;
        this.showLop = false;
        this.showWeel = false;
        this.showGuide = false;
        this.showlift = false;
    }
    pingyin(val) {
        let ss = '';
        if (val == '蓝光') {
            ss = 'blue';
        }
        if (val == '红光') {
            ss = 'red';
        }
        if (val == '绿光') {
            ss = 'green';
        }
        if (val == '橙光') {
            ss = 'orange';
        }
        if (val == '白光') {
            ss = 'white';
        }
        if (val == '有LOGO') {
            ss = 'With LOGO';
        }
        if (val == '镀色') {
            ss = 'With Color';
        }
        if (val == '带盲文') {
            ss = 'with_Braille';
        }
        if (val == '不带盲文') {
            ss = 'without_Braill';
        }
        if (val == '电梯轿厢控制板') {
            ss = 'Car Control Board';
        }
        if (val == '电梯指令板') {
            ss = 'Car Call Board';
        }
        return ss;
    }
    getList() {
        let param = JSON.parse(sessionStorage.getItem('form'));
        param.grade = sessionStorage.getItem('grade');
        order_1.getInstalledConfList(param).then(res => {
            let list = [[], [], [], [], [], []];
            res.forEach((item, index) => {
                this.activeNames.push(index);
                if (!item.orderNum)
                    item.orderNum = 1;
                if (item.typeName == 'Cabin') {
                    this.product = item;
                }
                if (item.superName == "Electric System")
                    list[0].push(item);
                if (item.superName == "Safety System")
                    list[1].push(item);
                if (item.superName == "Door System")
                    list[2].push(item);
                if (item.superName == "Traction System")
                    list[3].push(item);
                if (item.superName == "Guide Rail And Balance System")
                    list[4].push(item);
                if (item.superName == "Cabin Decoration System")
                    list[5].push(item);
            });
            this.list = list;
        });
    }
    getReplace(sysClassId, actualPrice, index, index2) {
        let param = JSON.parse(sessionStorage.getItem('form'));
        param.grade = sessionStorage.getItem('grade');
        param.sysClassId = sysClassId;
        this.thSource = index;
        this.thSource2 = index2;
        order_1.getInstalledConfList(param).then(res => {
            res.forEach((item, index) => {
                // item.actualPrice=5
                let disparity = item.actualPrice - actualPrice;
                item.disparity = disparity;
                if (!item.orderNum)
                    item.orderNum = 1;
            });
            this.replaceList = res;
        });
    }
    getChoice(item) {
        // console.log(item)
        this.$set(this.list[this.thSource], this.thSource2, item);
        this.dialogVisible = false;
    }
    mounted() {
        this.getList();
    }
};
__decorate([
    vue_property_decorator_1.Watch('num')
], About.prototype, "onChangeNum", null);
__decorate([
    vue_property_decorator_1.Watch('list', { immediate: true, deep: true })
], About.prototype, "onChangePrice", null);
About = __decorate([
    vue_property_decorator_1.Component({
        components: { HeaderTop: () => Promise.resolve().then(() => __importStar(require('@/components/HeaderTop/HeaderTop.vue'))), FooterBottom: () => Promise.resolve().then(() => __importStar(require('@/components/FooterBottom/Foot.vue'))), Create: createOrder_vue_1.default, copItem: cop_1.default,
            lopItem: Lop_1.default,
            wheelItem: wheel_1.default,
            guideItem: guide_1.default, }
    })
], About);
exports.default = About;
